import { useMemo } from 'react'
import uriToHttp from 'utils/uriToHttp'

export default function useHttpLocations(uri: string | undefined): string[] {
  return useMemo(() => (uri ? uriToHttp(uri) : []), [uri])
}
